import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface UseArtifactsProps {
  type?: 'all' | 'negotiator' | 'report' | 'cohort' | 'mortgage' | 'other';
  locationId?: string;
  sortBy?: string | string[];
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

interface Artifact {
  id: string;
  fileName: string;
  title: string;
  description: string;
  type: 'all' | 'negotiator' | 'report' | 'cohort' | 'mortgage' | 'other';
  accessLevel: 'public' | 'client' | 'internal';
  shareId: string;
  shareUrl: string;
  locationId?: string;
  startDate?: string;
  endDate?: string;
  createdAt: string;
  updatedAt: string;
  status?: 'queued' | 'processing' | 'done';
  jobId?: string;
}

interface ArtifactsResponse {
  data: Artifact[];
  pageNumber: number;
  pageSize: number;
  pageCount: number;
  totalPageCount: number;
  totalCount: number;
  message: string;
}

export const useArtifacts = ({
  locationId,
  sortBy,
  type = 'all',
  page = 1,
  pageSize = 10,
  enabled = true
}: UseArtifactsProps = {}) => {
  const queryParams = new URLSearchParams();

  if (locationId) {
    queryParams.append('locationId', locationId);
  }

  queryParams.append('type', type);


  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach(sort => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }

  queryParams.append('page', page.toString());
  queryParams.append('pageSize', pageSize.toString());

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['artifacts', locationId, page, pageSize, type, sortBy],
    queryFn: async () => {
      const response = await fetchAPI<ArtifactsResponse>({
        method: 'GET',
        route: 'artifacts/all',
        queryString
      });
      return response;
    },
    enabled,
    staleTime: 0
  });
};

export default useArtifacts;
